import { View } from 'react-native';

import { cn } from '@/components/ui/cn';

// Note: sizes/colors are selected as whole classes (never layered over a baked
// default) because `cn()` does not merge conflicting utilities — see the color
// note in WebLanding.

/** The little drawn check glyph. `size` picks the dimensions; `tone` the stroke color. */
export function Check({
  size = 'sm',
  tone = 'on-signal',
}: {
  size?: 'sm' | 'md';
  tone?: 'on-signal' | 'foreground-secondary';
}) {
  const dims = size === 'md' ? 'h-[7px] w-3' : 'h-[5px] w-[9px]';
  const stroke =
    tone === 'foreground-secondary' ? 'border-foreground-secondary' : 'border-on-signal';
  return (
    <View
      className={cn(dims, 'border-b-2 border-l-2', stroke)}
      style={{ transform: [{ rotate: '-45deg' }, { translateY: -1 }] }}
    />
  );
}
